import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { authApi } from "./auth-api";

type authState = "authenticated" | "unauthenticated" | "logout";

interface AuthSliceState {
  user: User | null;
  isAuthenticated: boolean;
  authState: authState;
}

const initialState: AuthSliceState = {
  user: null,
  isAuthenticated: false,
  authState: "unauthenticated",
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      if (state.authState !== "logout") state.authState = "authenticated";
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.login.matchFulfilled,
      (state, { payload }: { payload: User }) => {
        state.isAuthenticated = true;
        state.user = payload;
        state.authState = "authenticated";
      }
    ),
      builder.addMatcher(
        authApi.endpoints.logout.matchFulfilled,
        (state, _) => {
          state.isAuthenticated = false;
          state.authState = "logout";
          state.user = null;
          window.location.reload();
        }
      );
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
